import axios from "axios";
import fire from "@/config/fire.js";

const state = {
  userInfo: {
    placeholderData: true,
    firstName: "Sports Fan",
    lastName: "",
    year: "XXXX",
    repName: "Rep Name",
    repEmail: "ref@team.com",
    repPhone: "(000)-000-0000",
  },
  loadedItems: {
    images: false,
    video: false,
    userInfo: false,
    fonts: false,
  },
  allUserAccs: [],
  screenWidth: window.innerWidth,
  loggedIn: false,
  userData: null,
  accountType: "",
  totalStats: {
    outstanding: {
      masks: 0,
      caps: 0,
      other: 0,
    },
    complete: {
      masks: 0,
      caps: 0,
      other: 0,
    },
  },
};

const getters = {
  getUserInfo: (state) => state.userInfo,
};

const actions = {
  async fetchUserInfo({ commit }) {
    const purl = location.pathname.split("/").pop();
    const response = await axios.post(
      process.env.VUE_APP_BASE_URL + "/api/router/Users.php",
      {
        action: "getUserByPurl",
        prefix: "XXXXX",
        purl: purl,
        timestamp: new Date(),
      }
    );

    commit("setUserInfo", response ? response.data : "fetchUserInfoFailed");
    commit("setLoadedItem", {
      loadedProperty: "userInfo",
      isLoaded: true,
    });
  },
  async setLoadedItem({ commit }, payload) {
    commit("setLoadedItem", payload);
  },
  async setUserInfoObject({ commit }, payload) {
    commit("setUserInfoObject", payload);
  },
  async setScreenWidth({ commit }, payload) {
    commit("setScreenWidth", payload);
  },
  async setLoggedIn({ commit }, payload) {
    commit("setLoggedIn", payload, commit);
  },
  async setUserDataAndType({ commit }, payload) {
    commit("setUserDataAndType", payload);
  },
  async setUserData({ commit }, payload) {
    commit("setUserData", payload);
  },
  async setTotalStats({ commit }, payload) {
    commit("setTotalStats", payload);
  },
};

const mutations = {
  setUserInfo: (state, payload) => {
    if (!payload.output || payload.output.length < 1) return;
    let userInfo = payload.output[0];
    state.userInfo = userInfo;
    state.allUserAccs = payload.output;
  },
  setUserInfoObject: (state, payload) => {
    if (!payload) return;
    state.userInfo = payload;
  },
  setLoadedItem: (state, payload) => {
    state.loadedItems = {
      ...state.loadedItems,
      [payload.loadedProperty]: payload.isLoaded,
    };
  },
  setScreenWidth: (state, payload) => {
    state.screenWidth = payload;
  },
  setLoggedIn: (state, payload, commit) => {
    if (payload === true) {
      fetchUserData().then((data) => {
        if (!data) return;
        let userData = data.userData;
        state.accountType = data.accountType;
        state.userData = userData;
        if (userData.totalStats) {
          state.totalStats = userData.totalStats;
        }
      });
    } else {
      clearUserData(state);
    }
    state.loggedIn = payload;
  },
  setUserData: (state, payload) => {
    if (!payload) return;
    state.userData = payload;
  },
  setUserDataAndType: (state, payload) => {
    if (!payload) return;
    state.userData = payload.userData;
    state.accountType = payload.accountType;
    state.loggedIn = true;
  },
  setTotalStats: (state, payload) => {
    if (!payload) return;
    state.totalStats = payload;
  },
};

function clearUserData(state) {
  state.userData = null;
  state.accountType = "";
}

async function fetchUserData() {
  return new Promise((resolve, reject) => {
    getFireIdToken()
      .then((idToken) => {
        if (!idToken) return;
        axios.defaults.headers.common["Authorization"] = idToken;
        const url = process.env.VUE_APP_BASE_URL + "/api/userData";
        return axios({
          method: "put",
          url: url,
          headers: { Authorization: idToken },
          body: {
            idToken,
          },
        });
      })
      .then((res) => {
        if (res.data) {
          return resolve(res.data);
        }
      });
  });
}
function getFireIdToken() {
  return fire.auth().currentUser.getIdToken();
}

export default {
  state,
  getters,
  actions,
  mutations,
};
